// extracted by mini-css-extract-plugin
export default {"content":"Home_content__98LIx","homeContent":"Home_homeContent__4VRdb","loading":"Home_loading__1k1fD"};